import React, {useEffect, useState} from "react";
import ClearButtonInputAdornment from "../adornment/ClearButtonInputAdornment";
import {TextFieldBase, TextFieldBaseProps} from "./TextFieldBase";

export type TextFieldProps = Omit<TextFieldBaseProps, "onChange"> & {
    onChange?: (text: string) => void;
    errorMessage?: string,
    maxLength?: number,
    onClearButtonClick?: () => void;
    clearable?: boolean;
    readOnly?: boolean;
}

export default function TextField(props: TextFieldProps) {
    const {
        id,
        errorMessage,
        inputProps,
        InputLabelProps,
        InputProps,
        value,
        onChange,
        onClearButtonClick,
        clearable,
        error,
        helperText,
        ...rest
    } = props;
    const [text, setText] = useState(value);
    const [isFocused, setIsFocused] = useState<boolean>(false);
    const [isHovered, setIsHovered] = useState<boolean>(false);

    const maxLength = props.maxLength ?? inputProps?.maxLength;
    const errorFromErrorMessage = errorMessage !== undefined ? true : error;
    const helperTextFromErrorMessage = errorMessage ?? helperText;
    const fullWidth = props.fullWidth ?? true;

    useEffect(() => {
        setText(value);
    }, [value])

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };


    const createClearButtonAdornment = () => {
        if (clearable && onClearButtonClick !== undefined) {
            return <ClearButtonInputAdornment
                    visible={hasInputText() && (isFocused || isHovered)}
                    onClick={(e) => {
                        onClearButtonClick();
                        e.stopPropagation();
                    }}/>;
        } else if (clearable) {
            return <ClearButtonInputAdornment
                    visible={hasInputText() && (isFocused || isHovered)}
                    onClick={() => onTextChange("")}/>;
        } else {
            return undefined;
        }
    }

    function hasInputText(): boolean {
        return !!text;
    }

    const onTextChange = (newText: string) => {
        setText(newText);
        if (onChange) {
            onChange(newText);
        }
    }

    return (
        <TextFieldBase
                value={text}
                onChange={e => onTextChange(e.target.value)}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                error={errorFromErrorMessage}
                helperText={helperTextFromErrorMessage}
                fullWidth={fullWidth}
                inputProps={{
                    ...inputProps,
                    maxLength: maxLength
                }}
                InputLabelProps={{
                    ...InputLabelProps,
                }}
                InputProps={{
                    endAdornment: createClearButtonAdornment(),
                    ...InputProps,
                }}
                {...rest}
        />
    );
}
